'use client';

import { easeIn, easeOut, motion } from 'framer-motion';
import Image, { StaticImageData } from 'next/image';
import image1 from '@/public/global/trustChip/image1.png';
import image2 from '@/public/global/trustChip/image2.png';
import image3 from '@/public/global/trustChip/image3.png';
import image4 from '@/public/global/trustChip/image4.png';
import image5 from '@/public/global/trustChip/image5.svg';

interface TrustChipProps {
  className?: string;
}

export default function TrustChip({ className }: TrustChipProps) {
  const images = [image1, image2, image3, image4, image5];

  return (
    <motion.div className={className}>
      <div className="flex flex-row">
        {images.map((image, index) => (
          <motion.div
            key={index}
            initial={{
              opacity: 0,
              x: -200
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              duration: 0.75,
              ease: [0.76, 0, 0.24, 1],
              delay: (images.length - 1 - index) * 0.075
            }}
            className={index > 0 ? '-ml-[1rem]' : ''}
            style={{ zIndex: index + 1 }}
          >
            <Image
              src={image}
              alt={`Profile Image ${index + 1}`}
              className="w-[4rem] aspect-square rounded-full border-[0.125rem] border-white"
              quality={100}
            />
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
